type Status = 'live' | 'beta' | 'soon' | 'rate-limited' | 'pending' | 'active';

const styles: Record<
  Status,
  { bg: string; border: string; text: string; dot: string; label: string }
> = {
  live: {
    bg: 'bg-okSoft',
    border: 'border-ok/60',
    text: 'text-emerald-700 dark:text-emerald-300',
    dot: 'bg-ok',
    label: 'Live',
  },
  active: {
    bg: 'bg-okSoft',
    border: 'border-ok/60',
    text: 'text-emerald-700 dark:text-emerald-300',
    dot: 'bg-ok',
    label: 'Active',
  },
  beta: {
    bg: 'bg-cyanSoft',
    border: 'border-cyan/60',
    text: 'text-cyan-700 dark:text-cyan-300',
    dot: 'bg-cyan',
    label: 'Beta',
  },
  soon: {
    bg: 'bg-slate100',
    border: 'border-borderStrong',
    text: 'text-body',
    dot: 'bg-muted',
    label: 'Soon',
  },
  'rate-limited': {
    bg: 'bg-warnSoft',
    border: 'border-warn/60',
    text: 'text-amber-700 dark:text-amber-300',
    dot: 'bg-warn',
    label: 'Rate-limited',
  },
  pending: {
    bg: 'bg-slate100',
    border: 'border-borderStrong',
    text: 'text-body',
    dot: 'bg-muted',
    label: 'Pending invite',
  },
};

export default function StatusBadge({
  status,
  label,
  className = '',
}: {
  status: Status;
  label?: string;
  className?: string;
}) {
  const s = styles[status];
  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full border ${s.bg} ${s.border} ${s.text} px-2.5 py-0.5 text-[11px] font-semibold ${className}`}
    >
      <span className={`size-1.5 rounded-full ${s.dot}`} />
      {label ?? s.label}
    </span>
  );
}
